<template>
    <div class="flex-col-start-center font-normal bg-white border-r-5">
        <div class="bg-gray border-r-5 order-w margin-t-5 padding-10">
            <div class="flex-start">
                <p class="color-text color-zong margin-b-5 margin-r-5 font-mini">订单号：{{item.content.order_id}}</p>
            </div>
            <div v-for="(it, i) in item.content.goods" :key="i">
                <div class="flex-clo-star">
                    <p class="color-text color-zong margin-b-5 margin-r-5 font-mini">{{it.name}}</p>
                    <p >x{{it.nums}}</p>
                    <p class="font-mini">商品合计：￥<span class="font-big color-dark">{{it.price}}</span></p>
                </div>
                <div class="flex-start">
                    <div class="link-img img-fit-contain flex-shrink-0" style="height: 70px; width: 70px">
                        <img :src="it.image_url.indexOf('http') >= 0 ? it.image_url : 'http://mall.yingerfashion.com/' + it.image_url">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "msgOrderAsk",
        methods: {
            openGoodsModal(item) {
            let link = `http://mall.yingerfashion.com/yinger-m/index.html#/detailView?goods_id=${ item.goods_id }`
            window.open(link, '_blank', 'width=400,height=667,resizable=0,location=0')
            }
        }
    }
</script>

<style scoped>
    .line-h-20 {
        line-height: 20px;
    }
</style>
